import moment from "moment";
import React from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import { connect } from "react-redux";
import {
  addPublicFormAction,
  getPublicFormAction,
} from "../../actions/PublicFormsActions";
import { createTransactionAction } from "./../../actions/BuyerAgentMasterTemplateActions";
import {
  getLeadSourceOptionsAction,
  checkTransShortNameAction,
  changeTransactionStatusAction,
  getTimezoneListAction,
  createTaskAction,
} from "./../../actions/TransactionActions";
import { getAddressFromZipcodeAction } from "./../../actions/commonActions";
import {
  getContactByEmailAction,
  getContactsActions,
  getUserRolesAction,
  buyerAgentsAction,
  addQuickClientAction,
  getUserRolesActionNew,
  checkEmailOrMobileForQuickApp,
} from "./../../actions/UserActions";
import { getSubscriptionCounterAction } from "./../../actions/SubscriptionReportAction";
import { setFolderPermissionAction } from "../../actions/DocActions";
import APIUtil from "./../../config/APIUtil";
import UrlConstants from "./../../config/UrlConstants";
import {
  formatPhoneNumber,
  removeDashFromMobile,
  contigencyFormat,
  listingAgentDataFormat,
  closingAgentDataFormat,
  toastMessage,
  cryptoTokenDecode,
  getContingencyData,
  convertTimeToMinutes,
  getToday,
  currencyFormat,
  formatNumber,
  convertTZ,
  getUTCdate,
  getMinutesWithUTCTZ,
} from "./../Common/Common";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import { getTransactionTypeAction } from "./../../actions/TransactionTypeActions";
//import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import InputMask from "react-input-mask";
import DatePicker from "react-datepicker";
import SelectClientOrArtist from "../Transactions/Detail/SelectClientOrArtist";
import { Edit } from "@material-ui/icons";
import { adminGetQuickAppointmentTemplateAction } from "./../../actions/MasterTemplateActions";

class QuickAppointment extends React.Component {
  userType = cryptoTokenDecode().usertype;
  currentType = localStorage.getItem("currentRole");
  studioName = localStorage.getItem("companyName");

  constructor(props) {
    super(props);
    this.currentRole = !!this.currentType ? this.currentType.toUpperCase() : "";
    let year = new Date()
      .getFullYear()
      .toString()
      .substr(-2);
    this.state = {
      condo: false,
      builtBefore1978: false,
      hoa: false,
      homeWarranty: false,
      draft: false,
      leadSource: "",
      emd: "0",
      otherEMD: [],
      agreedOpenPrice: 0.0,
      commission: 100.0,
      transactionType: "Tattoo",
      property: {
        image: [],
        name: this.studioName,
        street: "",
        street1: "",
        city: "",
        zipcode: "",
        state: "",
      },
      buyer: {
        email: "",
        firstname: "",
        lastname: "",
        mobileNumber: "",
      },
      buyers: [],
      startDate: moment(),
      endDate: moment(),
      campaign: "",
      contingencies: [],
      contiUpdated: false,
      isShowPrompt: false,
      promptMsg: "",
      showLoader: false,
      fees: [],
      agentPercentage: 100,
      shortName: "DWRK" + year + Math.floor(1000 + Math.random() * 9000),
      heldBy: "",
      shortNameErr: "",
      listingAgents: [],
      closingAgents: [],
      contiChanged: false,
      listingAgentEdit: true,
      closingAgentEdit: true,
      userTimezone: "America/New_York",
      contacts: [],
      ownerId:
        cryptoTokenDecode().usertype === message.ACCTOWNER
          ? localStorage.getItem("ID")
          : localStorage.getItem("ownerId"),
      users: [],

      shortNameAccepted: undefined,
      nameBySystem: true,

      selectedDuration: "",
      eventStart: moment()
        .startOf("day")
        .add(12, "hours"),
      eventEnd: moment()
        .startOf("day")
        .add(13, "hours"),
      timezoneList: [],

      show1: false,
      role: "",
      value: "",
      callbyvalue: {},
      roleForGaurdian: "",
      dataOfChild: "",
      artist: {},
      artistFullName: "",

      clientFname: "",
      clientLname: "",
      clientEmail: "",
      clientMobile: "",
      firstNameErr: false,
      firstNameErrValidation: false,
      lastNameErr: false,
      artistErr: false,
      emailFormatErr: false,
      mobileFormatErr: false,
      mobileUnauthorized: false,
      emailUnauthorized: false,
      clientRoleId: "",
      existingUserData: false,
      mobileExists: false,
      emailExists: false,
      errMsg: "",
      redirectFlag: 0,
      isTextMsgEnabled: false,
    };
  }

  componentWillMount() {
    this.props.getTransactionTypeAction();
    this.props.getTimezoneListAction().then((res) => {
      // console.log("res", res);
      this.setState({ timezoneList: res });
    });
    this.props.adminGetQuickAppointmentTemplateAction().then((res) => {
      // console.log("adminGetQuickAppointmentTemplateAction res", res);
      this.setState({ contingencies: res.data.contingencies || [] });
      this.setState({ campaign: res.data._id || [] });
    });
    this.setDefaultDate(new Date());
    this.props.getUserRolesActionNew().then((res) => {
      // console.log("this.props.roles", this.props.roles);
      if (this.props.roles && this.props.roles.length > 0) {
        this.props.roles.map((x) => {
          if (x.name === "Client") {
            this.setState({
              clientRoleId: x._id,
            });
          }
        });
      }
    });
  }

  /**
   * @desc update transaction data with field name
   * @param {*} field
   * @param {*} value
   */
  updateTransactionData(field, value) {
    // console.log("==field==", field);
    // console.log("==field value==", value);
    switch (field) {
      case "property_street":
        return (this.state.property.street = value);
      case "property_street1":
        return (this.state.property.street1 = value);
      case "property_city":
        return (this.state.property.city = value);
      case "property_state":
        return (this.state.property.state = value);
      case "property_zipcode":
        return (this.state.property.zipcode = value);
      case "property_image":
        return (this.state.property.image = value);
      case "buyer_firstname":
        return (this.state.buyer.firstname = value);
      case "buyer_lastName":
        return (this.state.buyer.lastname = value);
      case "buyer_email":
        return (this.state.buyer.email = value);
      case "buyer_mobileNumber":
        return (this.state.buyer.mobileNumber = value);
      default: {
        var fieldState = {};
        fieldState[field] = value;
        return this.setState(fieldState);
      }
    }
  }

  setMobile(value, field) {
    var mob = value.replace(/-/g, "");
    this.updateTransactionData(field, mob);
  }

  //Check unique short name
  checkShortName = (name) =>
    new Promise((resolve, reject) => {
      this.props.checkTransShortNameAction(name).then((res) => {
        let isAccepted = false;
        if (res.status === code.ACCEPTED) {
          isAccepted = true;
          this.setState({ shortNameErr: "" });
        }
        resolve({ isAccepted: isAccepted });
      });
    });

  handleEventStartChange(date, type) {
    // console.log("handleEventStartChange date", date);
    // console.log("handleEventStartChange type", type);

    let dateStr = moment(date).format("YYYY-MM-DD");
    let timeStr = moment(date).format("HH:mm");

    // console.log("handleEventStartChange dateStr", dateStr);
    // console.log("handleEventStartChange timeStr", timeStr);

    if (type == "time") {
      dateStr = moment(this.state.eventStart).format("YYYY-MM-DD");
      // console.log("handleEventStartChange type time");
      // console.log("eventStart", this.state.eventStart);
      // console.log("dateStr", dateStr);
    }

    let finalDate = moment(dateStr + " " + timeStr);
    let timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    let formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );

    // console.log("handleEventStartChange finalDate", finalDate);
    // console.log("handleEventStartChange timeStamp", timeStamp);
    // console.log("handleEventStartChange formatedDate", formatedDate);
    // console.log(
    //   "this.state.transactionData.userTimezone",
    //   this.state.transactionData.userTimezone
    // );

    let eventDate = moment
      .tz(formatedDate, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
      .utc()
      .format();

    // console.log("277-formatedDate", formatedDate);
    // console.log("277-eventDate", eventDate);

    // console.log("handleEventStartChange eventDate as eventStart", eventDate);

    if (this.state.selectedDuration) {
      this.setState(
        {
          eventStart: date,
        },
        () => {
          this.setDuration(this.state.selectedDuration);
        }
      );
    } else {
      this.setState({
        eventStart: date,
      });
      let eventDate_endDate = moment
        .tz(formatedDate, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
        .add(1, "hours")
        .utc()
        .format();
      this.setState({
        eventEnd: moment(date).add(1, "hours"),
      });
    }
  }

  setDuration(e) {
    // console.log("setDuration e type", typeof e);
    this.setState({
      selectedDuration: e,
    });

    // console.log("setDuration e", e);
    // console.log("this.state.eventStart", this.state.eventStart);
    let startTime = new Date(this.state.eventStart);
    let duration = parseInt(e);
    let endTime = new Date(startTime.getTime() + duration * 60000);

    // console.log("setDuration startTime", startTime);
    // console.log("setDuration duration", duration);
    // console.log("setDuration endTime", endTime);

    let eventDate = moment
      .tz(endTime, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
      .utc()
      .format();

    // console.log("handleEventEndChange eventDate as eventEnd", eventDate);
    this.setState({
      eventEnd: endTime,
    });
    // this.handleEventEndChange(endTime, "time");
  }

  setDefaultDate(transStartDate) {
    let defStartDate = moment
      .tz(transStartDate, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
      .utc()
      .format();

    // console.log("defStartDate", defStartDate);

    let defEndDate = moment
      .tz(defStartDate, "YYYY-MM-DDTHH:mm:ssZ", this.state.userTimezone)
      .add(1, "hours")
      .utc()
      .format();

    // console.log("defEndDate", defEndDate);

    this.setState({
      eventStart: transStartDate,
      eventEnd: moment(transStartDate).add(1, "hours"),
      selectedDuration: "60",
    });
  }

  setModalOpen1(roleByonclick, value, e_id, itemObject) {
    // console.log("itemobjects",itemObject)
    this.setState({ callbyvalue: itemObject });
    this.setState({ value: value });
    this.setState({ dataOfChild: e_id || "" });
    if (
      roleByonclick == undefined ||
      roleByonclick == "" ||
      roleByonclick == null
    ) {
      this.setState({ role: "" });
      this.setState({ show1: !this.state.show1 });
    } else if (roleByonclick == "Guardian") {
      this.setState({ role: "Client" });
      this.setState({ roleForGaurdian: "Guardian" });
      this.setState({ show1: !this.state.show1 });
    } else {
      // console.log("=======role=======",roleByonclick)
      this.setState({ role: roleByonclick });
      this.setState({ roleForGaurdian: roleByonclick });
      this.setState({ show1: !this.state.show1 });
    }
  }

  DataOfChild = (item, roleofchild) => {
    // console.log("full contactssssssss", item);
    // console.log("roleofchild", roleofchild);
    //  console.log("kjxvkc=============>",this.state.roleForGaurdian)

    this.setState({ role: roleofchild });
    //  console.log("role ===>", this.state.role)

    this.setState({ dataOfChild: item._id });
    this.setState({ show1: !this.state.show1 });
    this.setAssignee(item._id, item);
  };

  setAssignee(e, fullcontactdata) {
    // console.log("setAssignee e ", e);
    let appointmentItem = {};
    let selectedArtist = [];

    selectedArtist.push({
      firstname: fullcontactdata.UserData[0].firstname,
      lastname: fullcontactdata.UserData[0].lastname,
      mobileNumber: fullcontactdata.UserData[0].mobileNumber,
      email: fullcontactdata.UserData[0].email.address,
      id: fullcontactdata.UserData[0]._id,
      contactId: fullcontactdata._id,
    });

    // console.log("selectedArtist", selectedArtist);
    let fullName =
      fullcontactdata.UserData[0].firstname +
      " " +
      fullcontactdata.UserData[0].lastname;

    this.setState({
      artist: selectedArtist,
      artistFullName: fullName,
      artistErr: false,
    });

    this.updateTransactionData("listingAgents", selectedArtist);

    // appointmentItem = {
    //   assignee: e,
    //   defaultAssignee: true,
    //   end: moment()
    //     .minutes(0)
    //     .add(1, "hour"),
    //   isActive: true,
    //   isParticipant: false,
    //   itemdefaultAssignee: false,
    //   key: "First Appointment",
    //   start: moment().minutes(0),
    //   val: "First Appointment",
    // };

    // for (let k = 0; k < this.state.contingencies.length; k++) {
    //   if (
    //     this.state.contingencies[k].key === "First Appointment"
    //   ) {
    //     this.state.contingencies[k] = appointmentItem;
    //   }
    //   if (
    //     this.state.contingencies[k].key === "Artist"
    //   ) {
    //     this.state.contingencies[k] = appointmentItem;
    //   }
    // }

    for (let k = 0; k < this.state.contingencies.length; k++) {
      if (this.state.contingencies[k].key === "First Appointment") {
        this.state.contingencies[k].assignee = e;
        this.state.contingencies[k].startDate = new Date(moment().minutes(0));
        this.state.contingencies[k].endDate = new Date(
          moment()
            .minutes(0)
            .add(1, "hour")
        );
      }
      if (this.state.contingencies[k].key === "Artist") {
        this.state.contingencies[k].assignee = e;
        this.state.contingencies[k].startDate = new Date(moment().minutes(0));
        this.state.contingencies[k].endDate = new Date(
          moment()
            .minutes(0)
            .add(1, "hour")
        );
      }
    }

    // console.log(
    //   "setAssignee this.state.contingencies ",
    //   this.state.contingencies
    // );
  }

  checkNameValidation(value) {
    let nameRegEx = /^[A-Za-z '-]{0,50}$/;
    if (value !== "") {
      if (nameRegEx.test(value)) {
        return true; // matched format
      } else {
        return false; // not matched format
      }
    }
  }

  checkFirstNameValidation(value) {
    if (value === "") {
      this.setState({ firstNameErr: true, firstNameErrValidation: false });
    } else {
      if (!this.checkNameValidation(value)) {
        this.setState({ firstNameErrValidation: true, firstNameErr: false });
      } else {
        this.setState({ firstNameErr: false, firstNameErrValidation: false });
      }
    }
  }

  checkLastNameValidation(value) {
    if (value !== "" && !this.checkNameValidation(value)) {
      this.setState({ lastNameErr: true });
    } else {
      this.setState({ lastNameErr: false });
    }
  }

  checkEmailValidation(value) {
    let emailRegEx = new RegExp("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$");
    if (value !== "") {
      if (emailRegEx.test(value)) {
        this.setState({
          emailFormatErr: false,
          existingUserData: false,
          emailUnauthorized: false,
          mobileExists: false,
          emailExists: false,
        });
        this.getExistingUserData("email", value);
      } else {
        this.setState({
          emailFormatErr: true,
          existingUserData: false,
          emailUnauthorized: false,
          mobileExists: false,
          emailExists: false,
        });
      }
    } else {
      this.setState({
        emailFormatErr: false,
        existingUserData: false,
        emailUnauthorized: false,
        mobileExists: false,
        emailExists: false,
      });
    }
  }

  checkMobileValidation(value) {
    if (value !== "") {
      //console.log("mobile val ==>", value);
      let mob = value.replace(/-/g, "");
      // console.log("mob val ==>", mob);
      // console.log("mob length ==>", mob.length);
      if (mob.length === 10) {
        this.setState({
          mobileFormatErr: false,
          existingUserData: false,
          mobileUnauthorized: false,
          mobileExists: false,
          emailExists: false,
        });
        this.getExistingUserData("mobile", mob);
      } else {
        this.setState({
          mobileFormatErr: true,
          existingUserData: false,
          mobileUnauthorized: false,
          mobileExists: false,
          emailExists: false,
        });
      }
    } else {
      this.setState({
        mobileFormatErr: false,
        existingUserData: false,
        mobileUnauthorized: false,
        mobileExists: false,
        emailExists: false,
      });
    }
  }

  checkValidations(flag) {
    this.setState({ redirectFlag: flag });

    let artistErr = false;
    let firstNameErr = false;

    if (Object.keys(this.state.artist).length <= 0) {
      this.setState({ artistErr: true });
      artistErr = true;
    }

    if (this.state.clientFname == "") {
      this.setState({ firstNameErr: true });
      firstNameErr = true;
    }

    if (
      !firstNameErr &&
      !this.state.lastNameErr &&
      !this.state.emailFormatErr &&
      !this.state.mobileFormatErr &&
      !this.state.emailUnauthorized &&
      !this.state.mobileUnauthorized &&
      !artistErr &&
      !this.state.firstNameErrValidation
    ) {
      this.setState({
        artistErr: false,
        firstNameErr: false,
        lastNameErr: false,
        emailFormatErr: false,
        mobileFormatErr: false,
        mobileUnauthorized: false,
        emailUnauthorized: false,
        firstNameErrValidation: false,
      });
      // console.log("good to store ******");
      this.createQuickClient();
    }
  }

  createQuickClient() {
     this.setState({
       showLoader: true,
     });
    let clientObj = {
      firstname: this.state.clientFname ? this.state.clientFname : "",
      lastname: this.state.clientLname ? this.state.clientLname : "",
      email: this.state.clientEmail ? this.state.clientEmail : "",
      mobileNumber: this.state.clientMobile ? this.state.clientMobile : "",
      role: this.state.clientRoleId,
      usertype: "VENDOR",
      ownerId: this.state.ownerId,
      color: "",
      roles: [this.state.clientRoleId],
      isTextMsgEnabled: this.state.isTextMsgEnabled,
    };
    // console.log("clientObj", clientObj);

    this.props
      .addQuickClientAction(clientObj)
      .then((res) => {
        // console.log("createQuickClient res", res);
        if (res.status === code.OK) {
          if (res.data) {
            if (res.data.userData) {
              let selectedClient = [];

              selectedClient.push({
                firstname: res.data.userData.firstname
                  ? res.data.userData.firstname
                  : "",
                lastname: res.data.userData.lastname
                  ? res.data.userData.lastname
                  : "",
                mobileNumber: res.data.userData.mobileNumber
                  ? res.data.userData.mobileNumber
                  : "",
                email:
                  res.data.userData.email && res.data.userData.email.address
                    ? res.data.userData.email.address
                    : "",
                id: res.data.userData._id,
                contactId: res.data._id,
              });

              // console.log("selectedClient", selectedClient);
              //this.updateTransactionData("buyer", selectedClient);
              this.updateTransactionData("buyers", selectedClient);
            }

            for (let k = 0; k < this.state.contingencies.length; k++) {
              if (this.state.contingencies[k].key === "Client") {
                this.state.contingencies[k].assignee = res.data
                  ? res.data._id
                  : "";
                this.state.contingencies[k].startDate = new Date(
                  moment().minutes(0)
                );
                this.state.contingencies[k].endDate = new Date(
                  moment()
                    .minutes(0)
                    .add(1, "hour")
                );
              }
            }

            // console.log(
            //   "createQuickClient this.state.contingencies ",
            //   this.state.contingencies
            // );
          }

          this.submitAction();
        } else if (res.status === code.FORBIDDEN) {
          // console.log("res===> ", res);
          this.setState({
            showLoader: false,
          });
          toastMessage(code.ERROR, res.data);
        } else {
          this.setState({
            showLoader: false,
          });
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * @desc cretate transaction api call with formated data
   */
  submitAction() {
    // console.log(
    //   "submitAction this.state.contingencies ===>",
    //   this.state.contingencies
    // );

    let eventStartUTC = getUTCdate(this.state.eventStart);
    let eventEndUTC = getUTCdate(this.state.eventEnd);

    this.setState({
      showLoader: true,
    });

    for (let k = 0; k < this.state.contingencies.length; k++) {
      if (this.state.contingencies[k].key === "First Appointment") {
        this.state.contingencies[k].startDate = eventStartUTC;
        this.state.contingencies[k].endDate = eventEndUTC;
      }
    }

    let data = this.state;

    //data.contingencies = contigencyFormat(this.state.contingencies);
    data.contingencies = this.state.contingencies;

    data.startDate = new Date(data.startDate);
    data.endDate = new Date(data.endDate);

    // console.log("submit data", data);

    if (data.campaign === "") {
      delete data.campaign;
    }

    if (data.property) {
      let zip = data.property.zipcode.toString();

      if (zip.length > 5) {
        let zipcode = removeDashFromMobile(data.property.zipcode);
        data.property.zipcode = zipcode;
      }
    }

    var fileNames = [];
    var formData = new FormData();
    data.property.image.forEach((file) => {
      if (file) {
        formData.append("file", file);
        fileNames.push(file.name);
      }
    });

    if (this.state.drafted !== undefined) {
      let fees = data.fees;
      fees.push(this.state.drafted);
      data.fees = fees;
    }

    if (this.state.draftedEMD !== undefined) {
      let otherEMD = data.otherEMD;
      otherEMD.push(this.state.draftedEMD);
      data.otherEMD = otherEMD;
    }

    if (data.leadSource == "") {
      delete data.leadSource;
    }

    if (data.agentPercentage == "") {
      data.agentPercentage = this.props.profileData.agentPercentage;
    }

    //calculate amount
    let commissionAmt = (data.agreedOpenPrice * data.commission) / 100;
    let agentPercentageAmt = (commissionAmt * data.agentPercentage) / 100;
    let brokerPercentageAmt = commissionAmt - agentPercentageAmt;

    let fees = data.fees;
    fees.push({ name: "Brokerage Fee", value: brokerPercentageAmt });
    data.fees = fees;

    //default buyer
    let defaultbuyer = data.buyer;
    let multibuyers = data.buyers;

    if (
      defaultbuyer.email !== "" ||
      defaultbuyer.firstname ||
      defaultbuyer.lastname !== "" ||
      defaultbuyer.mobileNumber !== ""
    ) {
      //add default buyer on 0th index
      multibuyers.unshift(defaultbuyer);
    }

    for (let b = 0; b < multibuyers.length; b++) {
      if (!!multibuyers[b] && !!multibuyers[b].mobileNumber) {
        multibuyers[b].mobileNumber = removeDashFromMobile(
          multibuyers[b].mobileNumber.toString()
        );
      }
    }
    data.buyer = multibuyers;
    delete data.buyers;

    // data.listingAgents = listingAgentDataFormat(data.listingAgents);
    // data.closingAgents = closingAgentDataFormat(data.closingAgents);

    let TransactionData = {
      draft: data.draft,
      hoa: data.hoa,
      builtBefore1978: data.builtBefore1978,
      homeWarranty: data.homeWarranty,
      condo: data.condo,
      fees: data.fees,
      buyer: multibuyers,

      emd: data.emd,
      otherEMD: data.otherEMD,
      heldBy: data.heldBy ? data.heldBy : "Quick Appointment",
      property: data.property,
      agreedOpenPrice: data.agreedOpenPrice,
      commission: data.commission,
      leadSource: data.leadSource,
      agentPercentage: data.agentPercentage,
      listingAgents: listingAgentDataFormat(data.listingAgents),
      closingAgents: closingAgentDataFormat(data.closingAgents),
    };
    data.dsd = TransactionData;

    // console.log("final data prepared", data);

    if (data.property.image.length > 0) {
      APIUtil.postFormDataMethod(
        UrlConstants.uploadPropertyImage,
        formData,
        true
      ).then((res) => {
        data.dsd.property.image = fileNames;
        if (res.status == code.OK) {
          this.createTransaction(data);
        } else {
          data.dsd.property.image = [];
          this.createTransaction(data);
        }
      });
    } else {
      data.dsd.property.image = [];
      this.createTransaction(data);
    }
  }

  getExistingUserData(name, value) {
    if (name === "email" && value !== "") {
      // console.log("getExistingUserData email call");
      this.props.checkEmailOrMobileForQuickApp(name, value).then((response) => {
        let res = response.data;
        if (response.status === 401) {
          // console.log("line 775");
          this.setState({
            emailUnauthorized: true,
            errMsg: response.data,
          });
        } else {
          if (Object.keys(res).length > 0) {
            if (res.isDeleted && res.isDeleted === true) {
              // console.log("line 782");
              this.setState({
                emailUnauthorized: true,
                errMsg: response.data,
              });
            } else {
              // console.log("line 787");
              this.setState({
                firstNameErr: false,
                firstNameErrValidation: false,
                existingUserData: true,
                emailUnauthorized: false,
                mobileExists: true,
                emailExists: false,
                clientMobile: res.mobileNumber,
                clientFname: res.firstname,
                clientLname: res.lastname,
                errMsg: "",
              });
            }
          } else {
            // console.log("line 799");
            this.setState({
              firstNameErr: false,
              firstNameErrValidation: false,
              existingUserData: false,
              emailUnauthorized: false,
              mobileExists: false,
              emailExists: false,
              clientMobile: this.state.clientMobile,
              clientFname: this.state.clientFname,
              clientLname: this.state.clientLname,
              errMsg: "",
            });
          }
        }
      });
    } else if (name === "mobile" && value !== "") {
      // console.log("getExistingUserData mobile call");
      this.props.checkEmailOrMobileForQuickApp(name, value).then((response) => {
        let res = response.data;
        if (response.status === 401) {
          // console.log("line 816");
          this.setState({
            mobileUnauthorized: true,
            errMsg: response.data,
          });
        } else {
          if (Object.keys(res).length > 0) {
            if (res.isDeleted && res.isDeleted === true) {
              // console.log("line 823");
              this.setState({
                mobileUnauthorized: true,
                errMsg: response.data,
              });
            } else {
              // console.log("line 828");
              this.setState({
                firstNameErr: false,
                firstNameErrValidation: false,
                existingUserData: true,
                mobileUnauthorized: false,
                mobileExists: false,
                emailExists: true,
                clientEmail: res.email.address,
                clientFname: res.firstname,
                clientLname: res.lastname,
                errMsg: "",
              });
            }
          } else {
            // console.log("line 840");
            this.setState({
              firstNameErr: false,
              firstNameErrValidation: false,
              existingUserData: false,
              mobileUnauthorized: false,
              mobileExists: false,
              emailExists: false,
              clientEmail: this.state.clientEmail,
              clientFname: this.state.clientFname,
              clientLname: this.state.clientLname,
              errMsg: "",
            });
          }
        }
      });
    }
  }

  redirectToSpecifiedPath(createdTrans) {
    //console.log('redirectToSpecifiedPath createdTrans',createdTrans);
    if (this.state.redirectFlag === 1) {
      this.props.history.push("/artwork");
    }
    if (this.state.redirectFlag === 2) {
      this.props.history.push({
        pathname: "/intake",
        createdTrans: createdTrans,
      });
    }
  }

  /**
   * @desc call api for create new transaction with given data
   * @param {*} data
   */
  createTransaction(data, createEvent, createPublicForm, grantPermissions) {
    // createEvent set as optional param (boolean)
    if (
      createEvent === undefined ||
      createEvent === false ||
      createEvent === 0 ||
      createEvent === ""
    ) {
      createEvent = false;
    }

    if (
      createPublicForm === undefined ||
      createPublicForm === false ||
      createPublicForm === 0 ||
      createPublicForm === ""
    ) {
      createPublicForm = false;
    }

    if (
      grantPermissions === undefined ||
      grantPermissions === false ||
      grantPermissions === 0 ||
      grantPermissions === ""
    ) {
      grantPermissions = false;
    }

    this.props.createTransactionAction(data).then((res) => {
      //console.log('createTransaction res',res);
      if (this.props.isTrascationCreated === true) {
        if (!data.draft) {
          let pdata = {
            status: "INPROGRESS",
            startDate: this.props.createTransactionData.startDate,
            endDate: this.props.createTransactionData.endDate,
          };
          pdata.showSuccessMessage = false;
          // console.log("i am 143", this.props.createTransactionData);
          this.props
            .changeTransactionStatusAction(
              this.props.createTransactionData._id,
              pdata
            )
            .then((res1) => {
              toastMessage(code.SUCCESS, "Artwork added");
              this.setState(this.defaultState);

              //this.props.history.push("/artwork");
              // console.log('changeTransactionStatusAction createTransaction res',res);
              // console.log('changeTransactionStatusAction createTransaction this.props.createTransactionData',this.props.createTransactionData);
              this.redirectToSpecifiedPath(res);

              // creating public forms + events
              createPublicForm = true;
              // if (createPublicForm) {
              //   let paperworkDate = getContingencyData(
              //     res.contingencies,
              //     "Paperwork",
              //     "startDate"
              //   );
              //   let newPublicForm = {
              //     form: "intake",
              //     transactionId: res._id,
              //     expiresOn: new Date(
              //       moment(paperworkDate).subtract(5, "days")
              //     ),
              //     auth: false,
              //   };
              //   this.props
              //     .addPublicFormAction(newPublicForm)
              //     .then((newPubRes1) => {});

              //   newPublicForm = {
              //     form: "consent",
              //     transactionId: res._id,
              //     expiresOn: new Date(
              //       moment(paperworkDate).subtract(5, "days")
              //     ),
              //     auth: false,
              //   };
              //   this.props
              //     .addPublicFormAction(newPublicForm)
              //     .then((newPubRes2) => {});

              //   newPublicForm = {
              //     form: "aftercare",
              //     transactionId: res._id,
              //     expiresOn: new Date(moment(paperworkDate).add(20, "days")),
              //     auth: false,
              //   };
              //   this.props
              //     .addPublicFormAction(newPublicForm)
              //     .then((newPubRes3) => {});
              // }
              // creating events
              createEvent = true;
              if (createEvent) {
                let contiDate = "";
                let contiTimeStr = "";
                let firstApptUTC = getContingencyData(
                  res.contingencies,
                  "First Appointment",
                  "startDate"
                );
                let firstApptDate = moment(firstApptUTC).format("M/DD/YYYY");
                let today = getToday();

                let eventStartUTC = getUTCdate(this.state.eventStart);
                let eventEndUTC = getUTCdate(this.state.eventEnd);
                let timeMin = getMinutesWithUTCTZ(
                  this.state.eventStart,
                  this.state.userTimezone
                );

                let newEventStart = eventStartUTC;
                let newEventEnd = eventEndUTC;
                let newEventTime = timeMin;
                let newEventAssigneeId = getContingencyData(
                  this.state.contingencies,
                  "First Appointment",
                  "assignee"
                );

                let newEvent = {
                  assignee: "@artist",
                  campaign: "",
                  communicationSubject: [""],
                  communicationTo: [""],
                  communicationToUserId: [newEventAssigneeId],
                  communicationType: "EMAIL",
                  contingency: "First Appointment",
                  day: 0,
                  description: [
                    "<p>First appointment with @client_firstname @client_lastname on @first_appointment_date.</p>\n",
                  ],
                  document: false,
                  // eventEndDate: "",
                  // eventStartDate: "",
                  eventEndDate: newEventEnd,
                  eventStartDate: newEventStart,
                  eventType: "INTERACTIVE",
                  isReminder: false,
                  reminderDate: "",
                  reminderTime: 480,
                  specialTask: ["Appointment"],
                  status: "SCHEDULED",
                  time: newEventTime,
                  timeZone: "240",
                  title: "First Appointment",
                  transactionId: res._id,
                };
                // if (
                //   newEvent.eventEndDate === "" &&
                //   newEvent.eventStartDate === "" &&
                //   newEvent.time === 0
                // ) {
                //   newEvent.eventEndDate = getContingencyData(
                //     res.contingencies,
                //     "First Appointment",
                //     "endDate"
                //   );
                //   newEvent.eventStartDate = getContingencyData(
                //     res.contingencies,
                //     "First Appointment",
                //     "startDate"
                //   );
                //   newEvent.communicationToUserId = getContingencyData(
                //     res.contingencies,
                //     "First Appointment",
                //     "assignee"
                //   );

                //   contiDate = new Date(newEvent.eventStartDate);
                //   contiTimeStr =
                //     contiDate.getHours() + ":" + contiDate.getMinutes();
                //   newEvent.time = convertTimeToMinutes(contiTimeStr);

                //   //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                // }
                if (newEvent.eventEndDate && newEvent.eventStartDate) {
                  this.props.createTaskAction(newEvent).then((res2) => {});
                }
                //   newEvent = {
                //     assignee: "@client",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: [""],
                //     communicationToUserId: [""],
                //     communicationType: "EMAIL",
                //     contingency: "Paperwork",
                //     day: 0,
                //     description: [
                //       "<p>@client_firstname, please complete the paperwork for your appointment with @artist_firstname @artist_lastname by the date indicated on this task. Links to the required forms have been sent to your email. Thanks!</p>\n",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "INTERACTIVE",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: ["Paperwork"],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "Paperwork",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     newEvent.eventEndDate = getContingencyData(
                //       res.contingencies,
                //       "Paperwork",
                //       "endDate"
                //     );
                //     newEvent.eventStartDate = getContingencyData(
                //       res.contingencies,
                //       "Paperwork",
                //       "startDate"
                //     );
                //     newEvent.communicationToUserId = getContingencyData(
                //       res.contingencies,
                //       "Paperwork",
                //       "assignee"
                //     );

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (newEvent.eventEndDate && newEvent.eventStartDate) {
                //     this.props.createTaskAction(newEvent).then((res2) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [
                //       "Your Appointment With @artist_firstname @artist_lastname",
                //     ],
                //     communicationTo: ["@client_email"],
                //     communicationType: "EMAIL",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "<p>Hey @client_firstname!</p><p></p><p>Your appointment with @artist_firstname @artist_lastname is on @first_appointment_date. See you then!</p>",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "First Appointment Reminder - Client Email",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     // //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     // //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     // //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventStartDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res3) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@client_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @client_firstname! Your appointment with @artist_firstname @artist_lastname is on @first_appointment_date. See you then!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "First Appointment Reminder - Client Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res4) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [
                //       "New Appointment With @client_firstname @client_lastname",
                //     ],
                //     communicationTo: ["@artist_email"],
                //     communicationType: "EMAIL",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       '<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="artist_firstname">@artist_firstname</a>!</p><p></p><p>Your appointment with <a href="" class="wysiwyg-mention" data-mention="" data-value="client_firstname">@client_firstname</a> <a href="" class="wysiwyg-mention" data-mention="" data-value="client_lastname">@client_lastname</a> is on @first_appointment_date. Details are in DotWork. Thanks!</p>',
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "New Appointment Scheduled - Artist Email",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res5) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@artist_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @artist_firstname! Your appointment with @client_firstname @client_lastname is on @first_appointment_date. Details are in DotWork. Thanks!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "New Appointment Scheduled - Artist Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res6) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@client_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @client_firstname, thanks for visiting us! Remember to follow the aftercare instructions provided by your artist, @artist_firstname @artist_lastname. If you have any questions or concerns, please contact @artist_firstname at @artist_phone. Enjoy your new tattoo!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 540,
                //     timeZone: "240",
                //     title: "Post-Appointment - Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === ""
                //   ) {
                //     contiDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );

                //     newEvent.eventEndDate = new Date(
                //       moment(contiDate).add(1, "days")
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(contiDate).add(1, "days")
                //     );

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res5) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@client_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @client_firstname! How's your tattoo doing? If it's okay with you, we'd love a pic. Just log into Dotwork https://www.dotworksoftware.com , go to your Artwork, and upload it to Healed Tattoo Photo under Tasks. Thanks!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 540,
                //     timeZone: "240",
                //     title: "Post-Healing Photo Upload Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === ""
                //   ) {
                //     contiDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );

                //     newEvent.eventEndDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res6) => {});
                //   }
                //   newEvent = {
                //     assignee: "@client",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: [""],
                //     communicationType: "EMAIL",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "<p>Hey @client_firstname! Please upload a photo of your healed tattoo to this task. Thanks!</p>\n",
                //     ],
                //     document: true,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "INTERACTIVE",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 540,
                //     timeZone: "240",
                //     title: "Healed Tattoo Photo",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === ""
                //   ) {
                //     contiDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );

                //     newEvent.eventEndDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res7) => {});
                //   }
              }
              // granting folder permissions
              grantPermissions = true;
              let hasGuardian =
                res.dsd.closingAgents.length === 0 ? false : true;
              if (grantPermissions && !hasGuardian) {
                let permissionObj = {
                  canView: true,
                  canAdd: true,
                  canMove: false,
                  canDelete: false,
                  userId: res.dsd.buyerId,
                };

                let permissionData = {
                  transactionId: res._id,
                  location: "Transaction Docs",
                  permission: permissionObj,
                };

                this.props
                  .setFolderPermissionAction(permissionData)
                  .then((permRes) => {});
              } else {
                let permissionObj = [];

                permissionObj.push(
                  {
                    canView: true,
                    canAdd: true,
                    canMove: false,
                    canDelete: false,
                    userId: res.dsd.closingAgents[0].id, // guardian details for default permissions
                  },
                  {
                    canView: true,
                    canAdd: true,
                    canMove: false,
                    canDelete: false,
                    userId: res.dsd.buyerId[0],
                  }
                );

                let permissionData = {
                  transactionId: res._id,
                  location: "Transaction Docs",
                  permission: permissionObj,
                };

                this.props
                  .setFolderPermissionAction(permissionData)
                  .then((permRes) => {});
              }
            });
        } else {
          this.setState(this.defaultState);
          this.props.history.push("/artwork");
        }
      } else {
        toastMessage(code.ERROR, res);
        this.setState(this.defaultState);
        this.props.history.push("/artwork");
      }
    });
  }

  render() {
    // console.log("render timezoneList", this.props.timezoneList);
    // console.log("render email exists status", this.state.emailExists);
    // console.log("render mobile exists status", this.state.mobileExists);

    // if (this.state.showLoader) {
    //   return (
    //     <div className="page-loader fixed">
    //       <div className="page-loader-inner">
    //         <div className="spinner-border" role="status">
    //           <span className="sr-only">Loading...</span>
    //         </div>
    //       </div>
    //     </div>
    //   );
    // }
      return (
        <div>
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col xs={12} sm={6}>
              <h4 className="title-med mt-0 pt-1">
                Create Quick Appointment
              </h4>
            </Col>

            <Col xs={12} sm={6} />
          </Row>
          {this.state.showLoader && (
            <div className="page-loader fixed">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          )}
          <div className="multi-step multi-step-admin">
            <div className="admin-steps admin-content-area">
              <div className="container-custom">
                <Form className="form-sm form-admin">
                  <Row>
                    <Col xs={12} sm={7}>
                      <Row>
                        <Col xs={12} sm={12}>
                          <Row>
                            <Col xs={12} sm={6}>
                              <div className="form-group">
                                <label>Artwork Type</label>
                                <div className="c-select">
                                  <select
                                    name="transactionType"
                                    className="form-control"
                                    value={this.state.transactionType}
                                    onChange={(e) => {
                                      this.updateTransactionData(
                                        "transactionType",
                                        e.target.value
                                      );
                                    }}
                                  >
                                    {this.props.transactionType &&
                                      this.props.transactionType.length >
                                        0 &&
                                      this.props.transactionType.map(
                                        (option) => {
                                          return (
                                            <option
                                              value={option.name}
                                              key={option._id}
                                            >
                                              {option.name}
                                            </option>
                                          );
                                        }
                                      )}
                                  </select>
                                </div>
                              </div>
                            </Col>
                            <Col xs={12} sm={6}>
                              <div className="form-group">
                                <label>Artwork ID</label>
                                <input
                                  type="text"
                                  name="shortName"
                                  value={this.state.shortName}
                                  maxLength={10}
                                  onChange={(event) => {
                                    this.setState({
                                      [event.target.name]:
                                        event.target.value,
                                      nameBySystem: false,
                                    });
                                    this.checkShortName(
                                      event.target.value
                                    ).then((res) => {
                                      if (res.isAccepted) {
                                        this.setState({
                                          shortNameAccepted: true,
                                        });
                                      } else {
                                        this.setState({
                                          shortNameAccepted: false,
                                        });
                                      }
                                    });
                                  }}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} sm={5}>
                              <div className="">
                                <label>
                                  Artist
                                  <span className="text-danger"> *</span>
                                </label>
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              sm={12}
                              style={{ display: "flex" }}
                            >
                              <input
                                type="text"
                                name="artist"
                                className="form-control field_ucfirst"
                                value={this.state.artistFullName}
                                readOnly
                              />
                              <Button
                                variant="transparent"
                                className="p-0"
                                onClick={() =>
                                  this.setModalOpen1(
                                    "Artist",
                                    this.state.artistFullName,
                                    this.state.dataOfChild
                                  )
                                }
                              >
                                <Edit fontSize="small" />
                              </Button>
                            </Col>
                            <Col xs={12}>
                              {this.state.artistErr && (
                                <div
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                >
                                  {"Artist is required"}
                                </div>
                              )}
                            </Col>
                          </Row>
                          <h4 className="title-small font-600 mt-4">
                            Client
                          </h4>
                          <Row>
                            <Col xs={12} sm={6}>
                              <div className="form-group">
                                <label>
                                  First Name
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="firstname"
                                  className="form-control field_ucfirst"
                                  value={this.state.clientFname}
                                  onChange={(e) => {
                                    this.updateTransactionData(
                                      "clientFname",
                                      e.target.value
                                    );
                                  }}
                                  onBlur={(e) => {
                                    this.checkFirstNameValidation(
                                      e.target.value
                                    );
                                  }}
                                  disabled={this.state.existingUserData}
                                />
                                {this.state.firstNameErr && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  >
                                    {message.ENTER_FIRST_NAME}
                                  </div>
                                )}
                                {this.state.firstNameErrValidation && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  >
                                    {message.ENTER_VALID_FIRST_NAME}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col xs={12} sm={6}>
                              <div className="form-group">
                                <label>Last Name</label>
                                <input
                                  type="text"
                                  name="lastname"
                                  className="form-control field_ucfirst"
                                  value={this.state.clientLname}
                                  onChange={(e) => {
                                    this.updateTransactionData(
                                      "clientLname",
                                      e.target.value
                                    );
                                  }}
                                  onBlur={(e) => {
                                    this.checkLastNameValidation(
                                      e.target.value
                                    );
                                  }}
                                  disabled={this.state.existingUserData}
                                />
                                {this.state.lastNameErr && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  >
                                    {message.ENTER_VALID_LAST_NAME}
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={12} sm={6}>
                              <div className="form-group">
                                <label>Email</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  value={this.state.clientEmail}
                                  onChange={(e) => {
                                    this.updateTransactionData(
                                      "clientEmail",
                                      e.target.value
                                    );
                                  }}
                                  onBlur={(e) => {
                                    // console.log("email onBlur call ===>");
                                    this.checkEmailValidation(
                                      e.target.value
                                    );
                                  }}
                                  disabled={this.state.emailExists}
                                />
                                {this.state.emailFormatErr && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  >
                                    {message.ENTER_VALID_EMAIL}
                                  </div>
                                )}
                                {this.state.emailUnauthorized && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  >
                                    {this.state.errMsg}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col xs={12} sm={6}>
                              <div className="form-group">
                                <label>Mobile Number</label>
                                <InputMask
                                  mask="999-999-9999"
                                  maskChar=""
                                  formcontrolprops={{
                                    fullWidth: true,
                                  }}
                                  className="form-control"
                                  name="mobileNumber"
                                  value={this.state.clientMobile}
                                  onChange={(e) => {
                                    this.setMobile(
                                      e.target.value,
                                      "clientMobile"
                                    );
                                  }}
                                  onBlur={(e) => {
                                    // console.log("mobile onBlur call ===>");

                                    this.checkMobileValidation(
                                      e.target.value
                                    );
                                  }}
                                  disabled={this.state.mobileExists}
                                >
                                  {/* {(inputProps) => <input {...inputProps} />} */}
                                </InputMask>
                                {this.state.mobileFormatErr && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  >
                                    {message.ENTER_VALID_MOBILE}
                                  </div>
                                )}
                                {this.state.mobileUnauthorized && (
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "block" }}
                                  >
                                    {this.state.errMsg}
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col xs={12} sm={6}>
                              <div className="form-group custom-control custom-checkbox custom-control-inline custom-privacy custom-privacy mt-2">
                                <input
                                  value={this.state.isTextMsgEnabled}
                                  type="checkbox"
                                  className="custom-control-input green-checkbox"
                                  id="isTextMsgEnabled"
                                  name="isTextMsgEnabled"
                                  onChange={(e) => {
                                    this.setState({
                                      isTextMsgEnabled: e.target.checked,
                                    })
                                  }}
                                />
                                <label
                                  className="custom-control-label f-10"
                                  htmlFor="isTextMsgEnabled"
                                >
                                  Opted In to receive text Messages
                                </label>
                              </div>
                            </Col>                            
                          </Row>
                          <Row>
                            <Col xs={12} sm={6}>
                              <div className="form-group">
                                <label>Timezone</label>
                                <div className="c-select">
                                  <select
                                    name="userTimezone"
                                    className="form-control"
                                    value={this.state.userTimezone}
                                    onChange={(e) => {
                                      this.updateTransactionData(
                                        "userTimezone",
                                        e.target.value
                                      );
                                    }}
                                  >
                                    {this.state.timezoneList &&
                                      this.state.timezoneList.length >
                                        0 &&
                                      this.state.timezoneList.map((e) => {
                                        return (
                                          <option
                                            key={e._id}
                                            value={e.value}
                                          >
                                            {e.displayText}
                                          </option>
                                        );
                                      })}
                                  </select>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <h4 className="title-small font-600 mt-2">
                            Appointment
                          </h4>
                          <Row>
                            <Col xs={12} sm={4}>
                              <div className="form-group">
                                <label className="date-label">Date</label>
                                <DatePicker
                                  minDate={new Date()}
                                  // selected={convertTZ(
                                  //   moment(this.state.eventStart),
                                  //   this.state.userTimezone
                                  // )}
                                  selected={
                                    new Date(this.state.eventStart)
                                  }
                                  onChange={(date) =>
                                    this.handleEventStartChange(
                                      date,
                                      "date"
                                    )
                                  }
                                  dateFormat="MM-d-yyyy"
                                  className="form-control form-control-sm pl-1 date-picker"
                                />
                              </div>
                            </Col>
                            <Col xs={12} sm={4}>
                              <div className="form-group">
                                <label className="date-label">Time</label>
                                <DatePicker
                                  // selected={convertTZ(
                                  //   moment(this.state.eventStart),
                                  //   this.state.userTimezone
                                  // )}
                                  selected={
                                    new Date(this.state.eventStart)
                                  }
                                  onChange={(date) =>
                                    this.handleEventStartChange(
                                      date,
                                      "time"
                                    )
                                  }
                                  showTimeSelect
                                  showTimeSelectOnly
                                  // minTime={
                                  //   new Date(new Date().setHours(8, 0, 0, 0))
                                  // }
                                  // maxTime={
                                  //   new Date(new Date().setHours(21, 0, 0, 0))
                                  // }
                                  timeIntervals={30}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  className="form-control form-control-sm pl-1 date-picker"
                                />
                              </div>
                            </Col>
                            <Col xs={12} sm={4}>
                              <div className="form-group">
                                <label className="date-label">
                                  Duration
                                </label>
                                <select
                                  className="form-control form-control-sm pl-1 date-picker date-duration"
                                  value={this.state.selectedDuration}
                                  onChange={(e) =>
                                    this.setDuration(e.target.value)
                                  }
                                >
                                  <option value={15}>15 minutes</option>
                                  <option value={20}>20 minutes</option>
                                  <option value={30}>30 minutes</option>
                                  <option value={45}>45 minutes</option>
                                  <option value={60}>1 hour</option>
                                  <option value={120}>2 hours</option>
                                  <option value={180}>3 hours</option>
                                  <option value={240}>4 hours</option>
                                </select>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Button
                    variant="primary"
                    size="sm"
                    className="btn-blue w-140 mb-5"
                    onClick={() => {
                      this.checkValidations(1);
                    }}
                    disabled={this.state.showLoader}
                  >
                    Save
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    className="btn-blue w-140 mb-5 ml-3"
                    onClick={() => {
                      this.checkValidations(2);
                    }}
                    disabled={this.state.showLoader}
                  >
                    Save & Open Intake Form
                  </Button>
                </Form>
              </div>
            </div>
          </div>

          <Modal
            show={this.state.show1}
            onHide={() => this.setModalOpen1()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className={
              this.state.roleForGaurdian == "Artist"
                ? "modal-med modal-art-deta"
                : "modal-med modal-art-deta modal-560"
            }
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Select Artist
                <h6 style={{ color: "Green" }}>{this.state.value}</h6>
              </Modal.Title>
            </Modal.Header>
            <SelectClientOrArtist
              DataOfChild={this.DataOfChild}
              role={this.state.role}
              previousData={this.state.dataOfChild}
            />
          </Modal>
        </div>
      );

  }
}

const mapStateToProps = (state) => {
  return {
    isTrascationCreated: state.reducer.isTrascationCreated,
    createTransactionData: state.reducer.createTransactionData,
    leadSourceOptions: state.reducer.options,
    profileData: state.reducer.profileData,
    timezoneList: state.reducer.timezoneList,
    transactionType: state.reducer.transactionType,
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    taskData: state.reducer.taskData,
    buyerAgents: state.reducer.buyerAgents,
    addPublicFormData: state.reducer.addPublicFormData,
    getPublicFormData: state.reducer.getPublicFormData,
    contact: state.reducer.contact,
  };
};

export default connect(
  mapStateToProps,
  {
    createTransactionAction,
    getLeadSourceOptionsAction,
    getAddressFromZipcodeAction,
    checkTransShortNameAction,
    changeTransactionStatusAction,
    getContactByEmailAction,
    getSubscriptionCounterAction,
    getTimezoneListAction,
    getTransactionTypeAction,
    getContactsActions,
    getUserRolesAction,
    createTaskAction,
    buyerAgentsAction,
    addPublicFormAction,
    getPublicFormAction,
    setFolderPermissionAction,
    adminGetQuickAppointmentTemplateAction,
    addQuickClientAction,
    getUserRolesActionNew,
    checkEmailOrMobileForQuickApp,
  }
)(QuickAppointment);
